import React, { useState, useEffect } from 'react';
import chromeIcon from '../styles/images/browser-icons/chrome-icon.svg';
import firefoxIcon from '../styles/images/browser-icons/firefox-icon.svg';
import safariIcon from '../styles/images/browser-icons/safari-icon.svg';
import operaIcon from '../styles/images/browser-icons/opera-icon.svg';

const BrowserRecommendationBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
  }, []);

  if (!visible) return null;

  return (
    <div className="browser-recommendation-banner">
      <div className="banner-content">
        <span className="banner-text">Surf on</span>
        <span className="icons">
          <img src={chromeIcon} alt="Chrome" />
          <img src={firefoxIcon} alt="Firefox" />
          <img src={safariIcon} alt="Safari" />
          <img src={operaIcon} alt="Opera" />
        </span>
        <span className="banner-text">for Optimal Experience</span>
      </div>

      <button type="button" className="close-btn" onClick={() => setVisible(false)} aria-label="Close banner">
        ×
      </button>
    </div>
  );
};

export default BrowserRecommendationBanner;
